export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "{filled} z {total} uzupełnionych": "{filled} of {total} completed",
        "%0 rozpoczętych checkoutów": "%0 checkouts started",
        "1 dzień": "1 day",
        "14 dni": "14 days",
        "3 dni": "3 days",
        "7 dni": "7 days",
        "Adres dostawy": "Delivery address",
        "Adres e-mail": "Email address",
        "Adres faktury": "Billing address",
        "Adres feedu": "Feed URL",
        "Adres IP": "IP address",
        "Aktualizuj cennik": "Update price list",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywność promocji": "Promotion activity",
        "Aktywny": "Active",
        "Alert": "Alert",
        "alertów": "alerts",
        "Anulowana": "Canceled",
        "Anulowane": "Canceled",
        "Anuluj": "Cancel",
        "Anuluj edycję": "Cancel edit",
        "API Key": "API Key",
        "API Key Location": "API Key Location",
        "API Key Tracking": "API Key Tracking",
        "Atrybuty": "Attributes",
        "Atrybuty i zawartość tego elementu są powtarzane dla każdego wpisu z wybranej listy (np. url → URL zdjęcia).": "Attributes and content of this item are repeated for each entry in selected list (e.g., url → image URL).",
        "Automatyczna akceptacja": "Automatic approval",
        "Automatycznie tworzone podsumowanie opinii o produkcie.": "Automatically generated summary of product reviews.",
        "Autor": "Author",
        "Autor opinii": "Review author",
        "Bez adresu email": "No email address",
        "Bez wyboru eksport obejmie wszystkie produkty.": "Without a category selection, all products will be exported.",
        "Bez wybranego źródła lista będzie iterować po głównej kolekcji danych.": "Without a selected source, list will iterate through main data collection.",
        "Bieżący okres": "Current period",
        "Bieżący stan produktu w magazynie.": "Current product stock status.",
        "Brak": "None",
        "Brak cech dla wybranych kategorii.": "No attributes for selected categories.",
        "Brak cech w grupie": "No attributes in group",
        "Brak cech wariantowych w kategoriach tego produktu.": "No variant attributes in this product's categories.",
        "Brak cenników. Dodaj cennik dla wybranego sklepu.": "No price lists. Add a price list for selected store.",
        "Brak danych": "No data",
        "Brak dostępnych dostaw dla wybranego kraju.": "No shipping options available for selected country.",
        "Brak dostępnych krajów.": "No countries available.",
        "Brak katalogów": "No catalogs",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak kategorii w grupie": "No categories in group",
        "Brak komentarza": "No comment",
        "Brak krajów": "No countries",
        "Brak kwoty do rozliczenia.": "No amount to settle.",
        "Brak miasta": "No city",
        "Brak odziedziczonych cech.": "No inherited attributes.",
        "Brak pasujących kategorii.": "No matching categories.",
        "Brak produktów komplementarnych.": "No complementary products.",
        "Brak produktów rekomendowanych.": "No recommended products.",
        "Brak produktów w kolekcji": "No products in collection",
        "Brak produktów w promocji": "No products on sale",
        "Brak skonfigurowanej zawartości.": "No content configured.",
        "Brak tłumaczenia": "No translation",
        "Brak treści opinii": "No review content",
        "Brak w magazynie": "Out of stock",
        "Brak witryn do przypisania.": "No sites to assign.",
        "Brak wybranych etykiet": "No labels selected",
        "Brak wybranych producentów": "No manufacturers selected",
        "Brak wybranych produktów": "No products selected",
        "Brak wybranych wartości": "No values selected",
        "Brak zdjęcia": "No image",
        "Brak zmian statusu.": "No status changes.",
        "Brakuje części lub elementów zestawu": "Some parts or set items are missing",
        "Brutto": "Gross",
        "Cecha": "Attribute",
        "Cecha nie ma jeszcze żadnych wartości.": "Attribute does not have any values yet.",
        "Cecha służy do rozróżniania wariantów produktu. Ustawienie można wybrać tylko przy tworzeniu cechy.": "Attribute is used to distinguish product variants. This setting can only be selected when creating an attribute.",
        "Cecha została dodana.": "Attribute has been added.",
        "Cecha została usunięta.": "Attribute has been deleted.",
        "Cecha została zaktualizowana.": "Attribute has been updated.",
        "Cechy": "Attributes",
        "Cechy odziedziczone po kategoriach nadrzędnych": "Attributes inherited from parent categories",
        "Cechy w grupie": "Attributes in group",
        "Cena aktualna": "Current price",
        "Cena aktualna brutto": "Current gross price",
        "Cena aktualna netto": "Current net price",
        "Cena brutto": "Gross price",
        "Cena brutto do": "Gross price to",
        "Cena brutto od": "Gross price from",
        "Cena do": "Price to",
        "Cena dostawy": "Shipping cost",
        "Cena łączna": "Total price",
        "Cena netto": "Net price",
        "Cena netto do": "Net price to",
        "Cena netto od": "Net price from",
        "Cena od": "Price from",
        "Cena produktów": "Product price",
        "Cena sugerowana brutto": "Suggested gross price",
        "Cena sugerowana dla wybranych produktów z zestawu": "Suggested price for selected products in the set",
        "Cena sugerowana netto": "Suggested net price",
        "Cena zamówienia": "Order price",
        "Cena została zdezaktywowana.": "Price has been deactivated.",
        "Cennik został dodany.": "Price list has been added.",
        "Cennik został zaktualizowany": "Price list has been updated",
        "Cenniki": "Price lists",
        "Ceny": "Prices",
        "Ceny bazowe produktu w dostępnych walutach.": "Base product prices in available currencies.",
        "Ceny dostawy": "Delivery prices",
        "Ceny elementów zestawu": "Prices of set items",
        "Ceny w pozostałych walutach przeliczane są względem domyślnej.": "Prices in other currencies are converted based on the default currency.",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "Co n-ty produkt gratis": "Every nth product free",
        "CRC": "CRC",
        "Customer ID": "Customer ID",
        "Cykl życia koszyka": "Cart lifecycle",
        "Czas dostawy": "Delivery time",
        "Czas na zgłoszenie reklamacji": "Time to submit a complaint",
        "Czas na zgłoszenie zwrotu": "Time to request a return",
        "Czas realizacji oraz dni i godziny wysyłki zamówień.": "Processing time and order shipping days and hours.",
        "Członkowie grupy klientów": "Customer group members",
        "Czy na pewno chcesz usunąć ten atrybut?": "Are you sure you want to delete this attribute?",
        "Czy na pewno chcesz usunąć ten element?": "Are you sure you want to delete this item?",
        "Czy na pewno chcesz usunąć ten warunek?": "Are you sure you want to delete this condition?",
        "Dane adresowe zapisane w zamówieniu.": "Address details saved in order.",
        "Dane do faktury": "Invoice details",
        "Dane dokumentu i rozliczenie należności.": "Document details and amount due settlement.",
        "Dane faktury": "Invoice details",
        "Dane grupy": "Group details",
        "Dane klienta": "Customer details",
        "Dane kraju": "Country details",
        "Dane połączenia z operatorem dostawy.": "Delivery provider connection details.",
        "Dane sklepu oraz sposób prezentacji cen.": "Store details and price display method.",
        "Dane zostały zapisane": "Data has been saved",
        "Darmowa dostawa": "Free delivery",
        "Darmowa dostawa od kwoty (brutto)": "Free delivery on orders over (gross)",
        "Darmowa przesyłka od kwoty (brutto)": "Free shipping on orders over (gross)",
        "Darmowy produkt": "Free product",
        "Data": "Date",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data modyfikacji pliku": "File modification date",
        "Data oceny": "Rating date",
        "Data od": "Date from",
        "Data ostatniego zamówienia": "Last order date",
        "Data płatności": "Payment date",
        "Data reklamacji": "Complaint date",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia publikacji jest wymagana": "Publication start date is required",
        "Data rozpoczęcia rekomendacji": "Recommendation start date",
        "Data ustawienia": "Date set",
        "Data utworzenia": "Creation date",
        "Data zakończenia": "End date",
        "Data zakończenia rekomendacji": "Recommendation end date",
        "Data zamówienia": "Order date",
        "Data zmiany ceny": "Price change date",
        "Dev": "Dev",
        "Dezaktywacja ceny jest nieodwracalna, a zdezaktywowana cena nie będzie brana pod uwagę przy obliczaniu najniższej ceny.": "Deactivating a price cannot be undone, and a deactivated price will not be considered when calculating the lowest price.",
        "Dezaktywacja zmiany ceny": "Price change deactivation",
        "Dezaktywuj": "Deactivate",
        "Dezaktywuj zmianę ceny": "Deactivate price change",
        "Dhl": "Dhl",
        "Długość kodu": "Code length",
        "dni": "days",
        "Do wysłania": "To be sent",
        "Dodaj": "Add",
        "Dodaj atrybut": "Add attribute",
        "Dodaj cechę": "Add feature",
        "Dodaj cechę do grupy": "Add feature to group",
        "Dodaj cennik": "Add price list",
        "Dodaj eksport": "Add export",
        "Dodaj element": "Add item",
        "Dodaj etykietę": "Add label",
        "Dodaj fakturę": "Add invoice",
        "Dodaj grupę cech": "Add feature group",
        "Dodaj grupę klientów": "Add customer group",
        "Dodaj katalog": "Add catalog",
        "Dodaj katalog, aby rozpocząć zarządzanie kategoriami.": "Add a catalog to start managing categories.",
        "Dodaj kategorię": "Add category",
        "Dodaj kody": "Add codes",
        "Dodaj kolekcję": "Add collection",
        "Dodaj kraj": "Add country",
        "Dodaj notatkę": "Add note",
        "Dodaj parametr UTM": "Add UTM parameter",
        "Dodaj pierwszy element struktury.": "Add the first structure item.",
        "Dodaj poniżej": "Add below",
        "Dodaj powiadomienie": "Add notification",
        "Dodaj powiązanie": "Add link",
        "Dodaj powyżej": "Add above",
        "Dodaj producenta": "Add manufacturer",
        "Dodaj produkt": "Add product",
        "Dodaj produkt do kolekcji": "Add product to collection",
        "Dodaj promocję": "Add promotion",
        "Dodaj promocję wiązaną": "Add bundle promotion",
        "Dodaj przecenę": "Add sale price",
        "Dodaj sklep": "Add store",
        "Dodaj sposób dostawy": "Add delivery method",
        "Dodaj sposób płatności": "Add payment method",
        "Dodaj stawkę": "Add rate",
        "Dodaj użytkownika": "Add user",
        "Dodaj walutę": "Add currency",
        "Dodaj wartość": "Add value",
        "Dodaj warunek": "Add condition",
        "Dodaj wewnątrz": "Add inside",
        "Dodaj właściwość": "Add property",
        "Dodaj wpis w kalendarzu": "Add calendar entry",
        "Dodaj zakres": "Add range",
        "Dodane przez": "Added by",
        "Dodanie cechy": "Adding feature",
        "Dodanie cennika": "Adding price list",
        "Dodanie eksportu": "Adding export",
        "Dodanie etykiety": "Adding label",
        "Dodanie faktury": "Adding invoice",
        "Dodanie grupy cech": "Adding feature group",
        "Dodanie grupy klientów": "Adding customer group",
        "Dodanie kategorii": "Adding category",
        "Dodanie kolekcji": "Adding collection",
        "Dodanie kraju": "Adding country",
        "Dodanie opcji dostawy": "Adding shipping option",
        "Dodanie opcji płatności": "Adding payment option",
        "Dodanie parametru UTM": "Adding UTM parameter",
        "Dodanie powiadomienia": "Adding notification",
        "Dodanie producenta": "Adding manufacturer",
        "Dodanie produktu": "Adding product",
        "Dodanie promocji kodów rabatowych": "Adding discount code promotion",
        "Dodanie promocji wiązanej": "Adding bundle promotion",
        "Dodanie przeceny produktów": "Adding product discount",
        "Dodanie sklepów": "Adding stores",
        "Dodanie stawki": "Adding rate",
        "Dodanie waluty": "Adding currency",
        "Dodanie wartości": "Adding value",
        "Dodanie wpisu do kalendarza": "Adding calendar entry",
        "Dodano do koszyka": "Added to bin",
        "Dodatkowe informacje o przeznaczeniu grupy.": "Additional information about the group's purpose.",
        "Dodatkowe materiały wizualne kolekcji.": "Additional visual materials for collection.",
        "Dodatkowe objaśnienie wartości. Treść można przygotować osobno dla każdego języka.": "Additional explanation of value. Content can be prepared separately for each language.",
        "Dodatkowe pola dla reklamacji": "Additional fields for complaints",
        "Dodatkowe wymagania dotyczące dostawy.": "Additional delivery requirements.",
        "Dodawaj, edytuj i porządkuj wartości.": "Add, edit, and organize values.",
        "Dodawanie elementów": "Adding items",
        "Dodawanie kodów": "Adding codes",
        "Dodawanie produktów, wybór kategorii lub import CSV.": "Adding products, selecting a category, or importing a CSV.",
        "Dokonaj dopłaty": "Make an additional payment",
        "Dokument faktury w formacie PDF.": "Invoice document in PDF format.",
        "Dokument jest pusty": "Document is empty",
        "Dokumenty i pliki do pobrania, maksymalnie 10 plików.": "Documents and files for download, up to 10 files.",
        "Domyślna waluta": "Default currency",
        "Domyślny limit (brutto)": "Default limit (gross)",
        "Dopłać": "Pay the difference",
        "Dopłacenie faktury": "Invoice surcharge",
        "Dostawa": "Delivery",
        "Dostawa na palecie": "Pallet delivery",
        "Dostawa w godzinach wieczornych": "Evening delivery",
        "Dostawa w sobotę": "Saturday delivery",
        "Dostawie nie przypisano żadnych form płatności": "No payment methods are assigned to this delivery",
        "Dostawy": "Deliveries",
        "Dostawy dla wybranego kraju oraz przypisane do nich formy płatności.": "Deliveries for selected country and payment methods assigned to them.",
        "Dostawy dostępne w kraju wybranego sklepu.": "Deliveries available in selected store's country.",
        "Dostawy i płatności": "Delivery and payments",
        "Dostępna liczba kodów możliwych do wygenerowania:": "Number of codes available for generation:",
        "Dostępne metody płatności": "Available payment methods",
        "Dostępność i ilości": "Availability and quantities",
        "Dostępność kolekcji w sklepie.": "Collection availability in store.",
        "Dostępny w magazynie": "In stock",
        "Dotpay": "Dotpay",
        "Dotyczy niezalogowanych klientów.": "Applies to customers who are not logged in.",
        "Drugi klucz (MD5)": "Second key (MD5)",
        "Działania masowe": "Bulk actions",
        "Dzień wysyłki": "Shipping day",
        "E-mail": "E-mail",
        "EAN-13": "EAN-13",
        "Edycja": "Edit",
        "Edycja cechy": "Edit feature",
        "Edycja cennika": "Edit price list",
        "Edycja eksportu": "Edit export",
        "Edycja etykiety": "Edit label",
        "Edycja grupy cech": "Edit feature group",
        "Edycja grupy klientów": "Edit customer group",
        "Edycja kategorii": "Edit category",
        "Edycja kodu rabatowego": "Edit discount code",
        "Edycja kolekcji": "Edit collection",
        "Edycja kraju": "Edit country",
        "Edycja opcji dostawy": "Edit shipping option",
        "Edycja opcji płatności": "Edit payment option",
        "Edycja parametru UTM": "Edit UTM parameter",
        "Edycja powiadomienia": "Edit notification",
        "Edycja producenta": "Edit manufacturer",
        "Edycja produktu": "Edit product",
        "Edycja promocji kodów rabatowych": "Edit discount code promotion",
        "Edycja promocji wiązanej": "Edit bundle promotion",
        "Edycja przeceny": "Edit discount",
        "Edycja przeceny produktów": "Edit product discount",
        "Edycja sklepów": "Edit stores",
        "Edycja stawki": "Edit rate",
        "Edycja stawki podatku": "Edit tax rate",
        "Edycja waluty": "Edit currency",
        "Edycja wartości": "Edit value",
        "Edycja wpisu do kalendarza": "Edit calendar entry",
        "Edytuj": "Edit",
        "Edytuj adres": "Edit address",
        "Edytuj notatkę": "Edit note",
        "Edytuj treść": "Edit content",
        "Edytuj treść opinii": "Edit review content",
        "Efekt": "Effect",
        "Efekty promocji": "Promotion effects",
        "Eksport kodów rabatowych został uruchomiony": "Discount code export has started",
        "Eksport został dodany.": "Export has been added.",
        "Eksport został usunięty.": "Export has been deleted.",
        "Eksport został zaktualizowany.": "Export has been updated.",
        "Eksportuj": "Export",
        "Eksportuj CSV": "Export CSV",
        "Eksporty": "Exports",
        "Element": "Item",
        "Element nie posiada jeszcze żadnych atrybutów": "Item does not have any attributes yet",
        "Element nie posiada jeszcze żadnych warunków": "Item does not have any conditions yet",
        "Elementy zestawu": "Set items",
        "Etykieta": "Label",
        "Etykieta priorytetowa": "Priority label",
        "Etykieta produktu została dodana.": "Product label has been added.",
        "Etykieta produktu została usunięta.": "Product label has been deleted.",
        "Etykieta produktu została zaktualizowana.": "Product label has been updated.",
        "Etykiety": "Labels",
        "Etykiety produktów": "Product labels",
        "Etykiety wyróżniające ten produkt w sklepie.": "Labels highlighting this product in the store.",
        "Faktura": "Invoice",
        "Faktura rozliczona w całości": "Invoice paid in full",
        "Faktura została dodana.": "Invoice has been added.",
        "Faktura została zaktualizowana.": "Invoice has been updated.",
        "Fakturę utwórz z poziomu zamówienia.": "Create invoice from order.",
        "Faktury": "Invoices",
        "Fałsz": "False",
        "Firma": "Company",
        "Filtry produktów": "Product filters",
        "Format": "Format",
        "Format cen i progi naliczania kosztów dostawy.": "Price format and shipping cost thresholds.",
        "Format ceny": "Price format",
        "Format i źródło określają strukturę feedu.": "Format and source define feed structure.",
        "Format kodu pocztowego": "ZIP code format",
        "Format kodu powinien być wyrażeniem regularnym.": "Code format should be a regular expression.",
        "Formularz": "Form",
        "Formy płatności powiązane z tą metodą dostawy.": "Payment methods associated with this shipping method.",
        "Galeria zdjęć produktu, maksymalnie 10 plików.": "Product image gallery, up to 10 files.",
        "Generowanie feedu zostało uruchomione.": "Feed generation has started.",
        "Generowanie kodów": "Code generation",
        "Generowanie korzysta z ostatnio zapisanej konfiguracji.": "Generation uses the most recently saved configuration.",
        "Generowanie, dopisywanie i obsługa indywidualnych kodów.": "Generating, adding, and managing individual codes.",
        "Generuj nowe kody": "Generate new codes",
        "Generuj opis": "Generate description",
        "Generuj opis produktu na podstawie parametrów": "Generate product description based on parameters",
        "Generuj warianty": "Generate variants",
        "Generuj wszystkie metadane": "Generate all metadata",
        "Głębokość": "Depth",
        "Głębokość paczki": "Package depth",
        "Godzina rozpoczęcia": "Start time",
        "Godzina wysyłki": "Shipping time",
        "Godzina wysyłki: {day}": "Shipping time: {day}",
        "Godzina zakończenia": "End time",
        "Grafika identyfikująca sposób płatności w sklepie.": "Image identifying payment method in the store.",
        "Grafika reprezentująca kolekcję.": "Image representing collection.",
        "Grafika wyświetlana przy tej metodzie dostawy.": "Image displayed for this shipping method.",
        "Grafiki wykorzystywane do prezentacji kategorii.": "Images used to present categories.",
        "Grupa cech": "Feature group",
        "Grupa cech została dodana.": "Feature group has been added.",
        "Grupa cech została usunięta.": "Feature group has been deleted.",
        "Grupa cech została zaktualizowana.": "Feature group has been updated.",
        "Grupa klientów": "Customer group",
        "Grupa klientów aktywna": "Customer group active",
        "Grupa klientów została dodana.": "Customer group has been added.",
        "Grupa klientów została usunięta.": "Customer group has been deleted.",
        "Grupa klientów została zaktualizowana.": "Customer group has been updated.",
        "Grupy cech": "Feature groups",
        "Grupy klientów": "Customer groups",
        "Happy hours": "Happy hours",
        "Hasło użytkownika": "User password",
        "Historia faktur": "Invoice history",
        "Historia powiadomień": "Notification history",
        "Historia przeglądania produktów": "Product browsing history",
        "Historia przeglądanych produktów": "Viewed product history",
        "Historia statusów": "Status history",
        "Historia wersji": "Version history",
        "Historia zamówień powiązanych z tym klientem.": "Order history associated with this customer.",
        "Historia zmian cen produktu": "Product price change history",
        "Historia zmian ceny": "Price change history",
        "Id": "Id",
        "ID": "ID",
        "ID autora": "Author ID",
        "ID katalogu": "Catalog ID",
        "ID kategorii głównej": "Main category ID",
        "ID kategorii nadrzędnej": "Parent category ID",
        "ID organizacji": "Organization ID",
        "ID podatku": "Tax ID",
        "Id punktu płatności (pos_id)": "Payment point ID (pos_id)",
        "ID sklepu": "Store ID",
        "ID użytkownika": "User ID",
        "ID użytkownika modyfikującego": "ID of user making changes",
        "Identyfikator i wartości używane do oznaczania ruchu.": "Identifier and values used to track traffic.",
        "Identyfikator klienta w koncie DHL.": "Customer ID in DHL account.",
        "Identyfikator organizacji w koncie InPost.": "Organization ID in InPost account.",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "Store identifier (seller ID by default)",
        "Identyfikator sprzedawcy": "Seller ID",
        "Identyfikator używany do rozpoznawania grupy w systemie.": "Identifier used to identify group in system.",
        "Identyfikatory": "Identifiers",
        "Ikona wartości": "Value icon",
        "Ilość": "Quantity",
        "Ilość dni po porzuceniu koszyka": "Number of days after cart abandonment",
        "Ilość ocen": "Number of ratings",
        "Ilość polubień": "Number of likes",
        "Ilość porzuconych koszyków": "Number of abandoned carts",
        "Ilość powtórzeń po wystąpieniu błędu": "Number of retries after an error",
        "Ilość produktu pozostawiana w magazynie. Pierwszeństwo ma ustawienie wariantu, następnie produktu, a na końcu kategorii.": "Quantity of product kept in stock. Variant setting takes precedence, followed by product setting, then category setting.",
        "Ilość produktu w zestawie": "Quantity of product in set",
        "Ilość reklamacji": "Number of complaints",
        "Ilość reklamowana": "Quantity complained about",
        "Ilość w magazynie": "Stock quantity",
        "Ilość w magazynie do": "Stock quantity to",
        "Ilość w magazynie od": "Stock quantity from",
        "Ilość zamówień": "Number of orders",
        "Ilość zwracana": "Quantity returned",
        "Ilości zarezerwowane w zamówieniach.": "Quantities reserved in orders.",
        "Imię": "First name",
        "Imię i nazwisko": "First and last name",
        "Imię klienta": "Customer first name",
        "Import CSV kategorii": "Category CSV import",
        "Import CSV produktów": "Product CSV import",
        "Import CSV zastąpi bieżącą listę produktów.": "CSV import will replace current product list.",
        "Import kategorii został rozpoczęty.": "Category import has started.",
        "Import produktów został rozpoczęty.": "Product import has started.",
        "Importuj": "Import",
        "Importuj CSV": "Import CSV",
        "Importuj schemat": "Import schema",
        "Indywidualny": "Individual",
        "Informacja dla klienta przy wyborze tej metody dostawy.": "Information for customer when choosing this delivery method.",
        "Informacje o produkcie": "Product information",
        "Informacyjna": "Informational",
        "Inny powód": "Other reason",
        "Inny problem z produktem": "Other problem with product",
        "Inpost": "Inpost",
        "Iteracja nastąpi po głównej kolekcji danych": "Iteration will take place after main data collection",
        "Iteracja po...": "Iteration over...",
        "Jakość produktu nie spełnia oczekiwań": "Product quality does not meet expectations",
        "Jednostka marginesu": "Margin unit",
        "Jednostka marginesu ilościowego": "Quantity margin unit",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, zostanie użyta nazwa kategorii.": "If display name is not set, category name will be used.",
        "Jeśli nie wybrano żadnego produktu, promocja obejmuje wszystkie produkty bez żadnych ograniczeń.": "If no product is selected, promotion applies to all products without any restrictions.",
        "Język": "Language",
        "Języki witryny {name}": "{name} site languages",
        "JSON konfiguracji": "Configuration JSON",
        "JSON nie jest zgodny z konfiguracją eksportu (name, source, format, schema).": "JSON does not match export configuration (name, source, format, schema).",
        "Kalendarz": "Calendar",
        "Kampania (utm_campaign)": "Campaign (utm_campaign)",
        "Kampanie": "Campaigns",
        "Katalog": "Catalog",
        "Katalog jest pusty.": "Catalog is empty.",
        "Katalog kategorii": "Category catalog",
        "Katalog produktów": "Product catalog",
        "Katalog z kategoriami został skopiowany.": "Catalog and categories have been copied.",
        "Katalog został usunięty.": "Catalog has been deleted.",
        "Katalog został utworzony.": "Catalog has been created.",
        "Katalogi kategorii": "Category catalogs",
        "Kategoria": "Category",
        "Kategoria główna": "Main category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria widoczna": "Category visible",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategorie": "Categories",
        "Kategorie, reguła podatku i producent.": "Categories, tax rule, and manufacturer.",
        "Kategoryzacja": "Categorization",
        "Klienci": "Customers",
        "Klient": "Customer",
        "Kliknij kategorię w drzewie po lewej, aby skonfigurować jej ustawienia, cechy i metadane.": "Click a category in the tree on the left to configure its settings, features, and metadata.",
        "Klucz API do śledzenia przesyłek.": "API key for shipment tracking.",
        "Klucz API punktów odbioru DHL.": "DHL pickup point API key.",
        "Klucz dostępu do API obsługującego przesyłki DHL.": "Access key for DHL shipment API.",
        "Kod": "Code",
        "Kod ISO": "ISO code",
        "Kod pocztowy": "Postal code",
        "Kod promocyjny": "Promo code",
        "Kod rabatowy": "Discount code",
        "Kod, symbol i zasady przeliczania cen.": "Code, symbol, and price conversion rules.",
        "Kodowanie (encoding)": "Encoding",
        "Kody identyfikujące produkt i jego pochodzenie.": "Codes identifying product and its origin.",
        "Kody promocyjne zostały dodane.": "Promo codes have been added.",
        "Kody promocyjne zostały wygenerowane.": "Promo codes have been generated.",
        "Kody rabatowe": "Discount codes",
        "Kody zostały zdezaktywowane.": "Codes have been deactivated.",
        "Kolejność wartości została zapisana.": "Value order has been saved.",
        "Kolekcja": "Collection",
        "Kolekcja aktywna": "Active collection",
        "Kolekcja została dodana.": "Collection has been added.",
        "Kolekcja została usunięta.": "Collection has been deleted.",
        "Kolekcja została zaktualizowana.": "Collection has been updated.",
        "Kolekcje": "Collections",
        "Kolekcje, do których należy produkt.": "Collections the product belongs to.",
        "Kolor / wzór nie odpowiada": "Color / pattern does not match",
        "Kolor dekoracji tekstu": "Text decoration color",
        "Kolor obramowania": "Border color",
        "Kolor tekstu": "Text color",
        "Kolor tła": "Background color",
        "Kolory": "Colors",
        "Kolory tła, tekstu, obramowania i dekoracji.": "Background, text, border, and decoration colors.",
        "Kolumna": "Column",
        "Kolumna ID musi zawierać dodatnie identyfikatory produktów.": "ID column must contain positive product IDs.",
        "Kolumna importu": "Import column",
        "Kolumna używana do wczytywania produktów": "Column used to load products",
        "Komentarz": "Comment",
        "Komentarz do zamówienia": "Order comment",
        "Kończy się na": "Ends with",
        "Konfiguracja": "Configuration",
        "Konfiguracja eksportu została załadowana.": "Export configuration has been loaded.",
        "Konfiguracja wybranego operatora płatności.": "Configuration for selected payment provider.",
        "Konfiguruj kategorię": "Configure category",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj katalog z kategoriami": "Copy catalog and categories",
        "Kopiuj punkt odbioru": "Copy pickup point",
        "Koszt dostawy": "Delivery cost",
        "Koszt dostawy w państwach": "Delivery cost in countries",
        "Koszt dostawy: {country}": "Delivery cost: {country}",
        "Koszt płatności": "Payment cost",
        "Koszt płatności brutto": "Gross payment cost",
        "Koszt płatności: {country}": "Payment cost: {country}",
        "Koszty wysyłki": "Shipping costs",
        "Koszyk usuwany": "Cart being deleted",
        "Koszyk uznany za opuszczony": "Cart considered abandoned",
        "Koszyki": "Carts",
        "Kraj": "Country",
        "Kraj określa dostępne stawki podatku oraz sposoby dostawy i płatności.": "Country determines available tax rates and delivery and payment methods.",
        "Kraj produkcji": "Country of manufacture",
        "Kraj rozliczenia i reguła podatku dla kosztów dostawy.": "Billing country and tax rule for shipping costs.",
        "Kraj rozliczenia kosztów dostawy. Po utworzeniu nie można go zmienić.": "Billing country for shipping costs. Cannot be changed after creation.",
        "Kraj został dodany.": "Country has been added.",
        "Kraj został usunięty.": "Country has been deleted.",
        "Kraj został zaktualizowany.": "Country has been updated.",
        "Kraje": "Countries",
        "Kraje produkcji": "Countries of manufacture",
        "Krótki opis prezentowany przy produkcie.": "Short description displayed with product.",
        "Krótki opis wartości…": "Short value description…",
        "Krótki opis, który ułatwi administratorom rozpoznanie przeznaczenia sklepu.": "Short description to help administrators identify store's purpose.",
        "Kurs": "Exchange rate",
        "Kurs podawany za tyle jednostek waluty.": "Exchange rate quoted per this many currency units.",
        "Kurs względem waluty domyślnej, podawany dla liczby jednostek określonej mnożnikiem.": "Exchange rate against default currency, quoted for number of units specified by multiplier.",
        "Kwota": "Amount",
        "Kwota brutto": "Gross amount",
        "Kwota dopłaty": "Surcharge amount",
        "Kwota netto": "Net amount",
        "Kwotowy": "Fixed amount",
        "Łącznie": "Total",
        "Legacy": "Legacy",
        "Liczba": "Number",
        "Liczba dni od ostatniej aktywności klienta.": "Number of days since customer's last activity.",
        "Liczba dni przechowywania": "Number of days to retain",
        "Liczba kategorii głównych": "Number of top-level categories",
        "Liczba nowych kodów": "Number of new codes",
        "Liczba użyć": "Number of uses",
        "Liczba wyników": "Number of results",
        "Liczba wyświetlanych produktów": "Number of products displayed",
        "Liczba zamówień": "Number of orders",
        "Liczony od utworzenia rezerwacji. Wpisz co najmniej 1 minutę.": "Counted from reservation creation. Enter at least 1 minute.",
        "Liczony od zmiany statusu zamówienia na Zrealizowane.": "Counted from when order status changes to Completed.",
        "Limit czasowy rezerwacji": "Reservation time limit",
        "Limit kupiecki": "Purchase limit",
        "Limity logistyczne": "Logistics limits",
        "Link do pełnej dokumentacji": "Link to full documentation",
        "Lista": "List",
        "Logo": "Logo",
        "Logo i płatności": "Logo and payments",
        "Logo sposobu płatności": "Payment method logo",
        "Logo, zdjęcie i pliki producenta.": "Manufacturer logo, photo, and files.",
        "Lub (or)": "Or (or)",
        "Lub wpisz wartość": "Or enter a value",
        "Lub wybierz kolumnę CSV": "Or select a CSV column",
        "Maksimum logistyczne": "Maximum logistics level",
        "Maksymalna liczba pozycji przechowywanych w historii.": "Maximum number of items stored in history.",
        "Maksymalna liczba produktów": "Maximum number of products",
        "Maksymalna liczba użyć": "Maximum number of uses",
        "Maksymalna wartość rabatu": "Maximum discount value",
        "Maksymalna wartość zamówienia": "Maximum order value",
        "Maksymalny poziom logistyczny zapasu produktów.": "Maximum logistics level of product stock.",
        "Margines dla produktów": "Product margin",
        "Margines ilościowy": "Quantity margin",
        "Marketing": "Marketing",
        "Media": "Media",
        "Medium (utm_medium)": "Medium (utm_medium)",
        "Metadane": "Metadata",
        "Miasto": "City",
        "min": "min",
        "Miniaturka": "Thumbnail",
        "Minimalna i maksymalna ilość produktu.": "Minimum and maximum product quantity.",
        "Minimalny poziom logistyczny zapasu produktów.": "Minimum logistics level of product stock.",
        "Minimum logistyczne": "Minimum logistics level",
        "Mniejsze lub równe": "Less than or equal to",
        "Mniejsze niż": "Less than",
        "Mnożnik": "Multiplier",
        "Moduł dostawy": "Delivery module",
        "Moduł płatności": "Payment module",
        "Modułu nie można zmienić po utworzeniu.": "Module cannot be changed after creation.",
        "MPN": "MPN",
        "Multimedia": "Multimedia",
        "Na status": "To status",
        "Nadkreślenie": "Overline",
        "Najgłębszy poziom kategorii, na którym mają pojawić się kafelki.": "Deepest category level at which tiles should appear.",
        "Najniższa cena z 30 dni brutto": "Lowest gross price in last 30 days",
        "Najpierw wybierz wariant przeliczenia": "First select conversion option",
        "Najpierw zapisz wprowadzone zmiany": "First save your changes",
        "Nazwa": "Name",
        "Nazwa atrybutu": "Attribute name",
        "Nazwa cechy": "Feature name",
        "Nazwa eksportu": "Export name",
        "Nazwa elementu": "Item name",
        "Nazwa etapu": "Stage name",
        "Nazwa firmy": "Company name",
        "Nazwa grupy cech": "Feature group name",
        "Nazwa grupy w panelu oraz jej wersje wyświetlane w sklepie.": "Group name in control panel and its versions displayed in store.",
        "Nazwa grupy wyświetlana w panelu administracyjnym.": "Group name displayed in admin panel.",
        "Nazwa i identyfikator kolekcji produktów.": "Product collection name and identifier.",
        "Nazwa i okres obowiązywania wpisu.": "Entry name and validity period.",
        "Nazwa i zasady działania grupy klientów.": "Customer group name and rules.",
        "Nazwa katalogu": "Catalog name",
        "Nazwa kategorii używana w panelu oraz jako domyślna nazwa wyświetlana.": "Category name used in control panel and as default display name.",
        "Nazwa klienta": "Customer name",
        "Nazwa kolekcji": "Collection name",
        "Nazwa parametru": "Parameter name",
        "Nazwa pokazywana klientowi w wybranym języku.": "Name shown to customer in selected language.",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa prezentowana klientom sklepu. Uzupełnij ją osobno dla każdego języka.": "Name shown to store customers. Enter it separately for each language.",
        "Nazwa prezentowana klientom. Uzupełnij ją osobno dla każdego języka.": "Name shown to customers. Enter it separately for each language.",
        "Nazwa producenta": "Manufacturer name",
        "Nazwa producenta i jego widoczność w sklepie.": "Manufacturer name and visibility in store.",
        "Nazwa produktu": "Product name",
        "Nazwa promocji": "Promotion name",
        "Nazwa promocji wiązanej": "Bundle promotion name",
        "Nazwa przeceny": "Discount name",
        "Nazwa sklepu": "Store name",
        "Nazwa sposobu dostawy": "Delivery method name",
        "Nazwa sposobu płatności": "Payment method name",
        "Nazwa stawki i domyślna reguła dla produktów.": "Rate name and default rule for products.",
        "Nazwa systemowa": "System name",
        "Nazwa ułatwiająca rozpoznanie grupy cech w panelu.": "Name that helps identify feature group in admin panel.",
        "Nazwa ułatwiająca rozpoznanie metody dostawy w panelu.": "Name that helps identify delivery method in admin panel.",
        "Nazwa ułatwiająca rozpoznanie wpisu w kalendarzu.": "Name that helps identify calendar entry.",
        "Nazwa użytkownika": "Username",
        "Nazwa używana do rozpoznania cechy w panelu administracyjnym.": "Name used to identify feature in admin panel.",
        "Nazwa widoczna na liście sklepów i w panelu administracyjnym.": "Name shown in store list and admin panel.",
        "Nazwa widoczna w sklepie": "Name shown in store",
        "Nazwa wpisu do kalendarza": "Calendar entry name",
        "Nazwa wyświetlana": "Display name",
        "Nazwa, adres i treść kategorii.": "Category name, URL, and content.",
        "Nazwa, dostępność i treści prezentowane klientom sklepu.": "Name, availability, and content shown to store customers.",
        "Nazwa, identyfikator i waluta kraju.": "Country name, identifier, and currency.",
        "Nazwa, priorytet i okres wyświetlania etykiety.": "Label name, priority, and display period.",
        "Nazwa, sklep i zakres działania promocji.": "Promotion name, store, and scope.",
        "Nazwa, widoczność i opis metody dostawy w sklepie.": "Delivery method name, visibility, and description in store.",
        "Nazwisko": "Last name",
        "Nazwisko klienta": "Customer's last name",
        "Nazwy": "Names",
        "Nazwy i opis identyfikujący produkt w katalogu.": "Names and description identifying product in catalog.",
        "Nazwy, grupa i zasady uzupełniania cechy w produktach.": "Names, group, and rules for adding feature values to products.",
        "Netto": "Net",
        "Nie": "No",
        "Nie dodano jeszcze żadnej cechy.": "No features have been added yet.",
        "Nie działa jedna z funkcji produktu": "One of product's functions is not working",
        "Nie importuj": "Do not import",
        "Nie pozwól": "Do not allow",
        "Nie przypisano jeszcze żadnej kategorii.": "No category has been assigned yet.",
        "Nie przypisano kolekcji.": "No collection assigned.",
        "Nie przypisano żadnej etykiety.": "No label assigned.",
        "Nie udało się odczytać pliku CSV.": "Could not read CSV file.",
        "Nie udało się pobrać cech kategorii.": "Could not load category features.",
        "Nie udało się pobrać listy kategorii.": "Could not load category list.",
        "Nie udało się pobrać reklamacji.": "Could not load complaints.",
        "Nie udało się przeszukać kategorii.": "Could not search categories.",
        "Nie udało się rozpocząć importu kategorii.": "Could not start category import.",
        "Nie udało się rozpocząć importu produktów.": "Could not start product import.",
        "Nie udało się skopiować danych do schowka.": "Could not copy data to clipboard.",
        "Nie udało się wczytać cech produktu.": "Could not load product features.",
        "Nie udało się wczytać cech.": "Could not load features.",
        "Nie udało się wczytać cechy.": "Could not load feature.",
        "Nie udało się wczytać cennika.": "Could not load price list.",
        "Nie udało się wczytać części danych pomocniczych.": "Could not load some auxiliary data.",
        "Nie udało się wczytać członków grupy.": "Could not load group members.",
        "Nie udało się wczytać danych klienta.": "Could not load customer data.",
        "Nie udało się wczytać dostaw dla wybranego sklepu.": "Could not load deliveries for selected store.",
        "Nie udało się wczytać eksportu.": "Could not load export.",
        "Nie udało się wczytać etykiet.": "Could not load labels.",
        "Nie udało się wczytać faktur.": "Could not load invoices.",
        "Nie udało się wczytać faktury.": "Could not load invoice.",
        "Nie udało się wczytać formularza. Spróbuj ponownie.": "Could not load form. Try again.",
        "Nie udało się wczytać grup cech.": "Could not load feature groups.",
        "Nie udało się wczytać grup klientów.": "Could not load customer groups.",
        "Nie udało się wczytać grupy cech.": "Could not load feature group.",
        "Nie udało się wczytać grupy klientów.": "Could not load customer group.",
        "Nie udało się wczytać historii cen.": "Could not load price history.",
        "Nie udało się wczytać historii wersji.": "Could not load version history.",
        "Nie udało się wczytać katalogów.": "Could not load catalogs.",
        "Nie udało się wczytać kategorii.": "Could not load categories.",
        "Nie udało się wczytać klientów.": "Could not load customers.",
        "Nie udało się wczytać kodów.": "Could not load codes.",
        "Nie udało się wczytać kolekcji.": "Could not load collections.",
        "Nie udało się wczytać konfiguracji wariantów.": "Could not load variant configuration.",
        "Nie udało się wczytać krajów.": "Could not load countries.",
        "Nie udało się wczytać listy.": "Could not load list.",
        "Nie udało się wczytać nazw powiązanych elementów.": "Could not load names of related items.",
        "Nie udało się wczytać nazw produktów.": "Could not load product names.",
        "Nie udało się wczytać notatek.": "Could not load notes.",
        "Nie udało się wczytać opinii.": "Could not load reviews.",
        "Nie udało się wczytać podatków.": "Could not load taxes.",
        "Nie udało się wczytać pól źródła danych.": "Could not load data source fields.",
        "Nie udało się wczytać producentów.": "Could not load manufacturers.",
        "Nie udało się wczytać produktów zestawu.": "Could not load bundle products.",
        "Nie udało się wczytać produktów.": "Could not load products.",
        "Nie udało się wczytać produktu.": "Could not load product.",
        "Nie udało się wczytać promocji.": "Could not load promotions.",
        "Nie udało się wczytać przypisanych cech.": "Could not load assigned features.",
        "Nie udało się wczytać sklepów.": "Could not load stores.",
        "Nie udało się wczytać sklepu.": "Could not load store.",
        "Nie udało się wczytać sposobów dostawy.": "Could not load delivery methods.",
        "Nie udało się wczytać sposobów płatności.": "Could not load payment methods.",
        "Nie udało się wczytać sposobu dostawy.": "Could not load delivery method.",
        "Nie udało się wczytać sposobu płatności.": "Could not load payment method.",
        "Nie udało się wczytać ustawień generowania kodów.": "Could not load code generation settings.",
        "Nie udało się wczytać ustawień.": "Could not load settings.",
        "Nie udało się wczytać walut.": "Could not load currencies.",
        "Nie udało się wczytać wariantów.": "Could not load variants.",
        "Nie udało się wczytać wartości cechy.": "Could not load feature value.",
        "Nie udało się wczytać zamówień.": "Failed to load orders.",
        "Nie udało się wczytać zamówienia.": "Failed to load order.",
        "Nie udało się wczytać zgłoszenia.": "Failed to load ticket.",
        "Nie udało się wczytać zwrotów.": "Failed to load returns.",
        "Nie udało się zapisać kolejności. Spróbuj ponownie.": "Failed to save order. Please try again.",
        "Nie uwzględniaj dla produktów z dostawą na palecie": "Do not include for products shipped on a pallet",
        "Nie uzupełniono": "Not completed",
        "Nie wybrano pliku": "No file selected",
        "Nie wybrano żadnej opinii.": "No reviews selected.",
        "Nie wybrano żadnych etykiet.": "No labels selected.",
        "Nie zawiera": "Does not contain",
        "Nie znaleziono wybranego produktu.": "Selected product not found.",
        "Nieaktywna": "Inactive",
        "Nieaktywna kolekcja nie jest widoczna w sklepie.": "Inactive collection is not visible in the store.",
        "Nieaktywne": "Inactive",
        "Niekompletny zestaw / brak akcesoriów": "Incomplete set / accessories missing",
        "Niektóre wersje językowe zostały już przypisane do innych sklepów.": "Some language versions have already been assigned to other stores.",
        "Nielimitowana": "Unlimited",
        "Niestandardowa wiadomość": "Custom message",
        "NIP": "Tax ID",
        "Notatka": "Note",
        "Notatka administracyjna": "Administrative note",
        "Notatka administracyjna została zapisana.": "Administrative note has been saved.",
        "Notatka została usunięta.": "Note has been deleted.",
        "Notatka została zapisana.": "Note has been saved.",
        "Notatki": "Notes",
        "Nowa cecha": "New feature",
        "Nowa etykieta": "New label",
        "Nowa faktura": "New invoice",
        "Nowa grupa cech": "New feature group",
        "Nowa grupa klientów": "New customer group",
        "Nowa kolekcja": "New collection",
        "Nowa opcja dostawy": "New delivery option",
        "Nowa promocja wiązana": "New bundle promotion",
        "Nowa przecena": "New sale",
        "Nowa stawka podatku": "New tax rate",
        "Nowa waluta": "New currency",
        "Nowe": "New",
        "Nowe powiadomienie": "New notification",
        "Nowe warianty": "New variants",
        "Nowe zgłoszenie": "New ticket",
        "Nowy eksport": "New export",
        "Nowy kod rabatowy": "New discount code",
        "Nowy kraj": "New country",
        "Nowy parametr UTM": "New UTM parameter",
        "Nowy producent": "New manufacturer",
        "Nowy produkt": "New product",
        "Nowy sklep": "New store",
        "Nowy sposób płatności": "New payment method",
        "Nowy wpis w kalendarzu": "New calendar entry",
        "np. Apple A19 Pro": "e.g. Apple A19 Pro",
        "np. Podzespoły": "e.g. Components",
        "np. Procesor": "e.g. Processor",
        "np. Sklep główny": "e.g. Main store",
        "Numer": "Number",
        "Numer budynku": "Building number",
        "Numer domu / mieszkania": "House / apartment number",
        "Numer faktury": "Invoice number",
        "Numer kierunkowy": "Dialing code",
        "Numer konta": "Account number",
        "Numer reklamacji": "Complaint number",
        "Numer zamówienia": "Order number",
        "Numer zgłoszenia": "Ticket number",
        "Numer zwrotu": "Return number",
        "Obiekt": "Object",
        "Ocena": "Rating",
        "Ocena do": "Rating to",
        "Ocena od": "Rating from",
        "Oceniony produkt": "Rated product",
        "Oczekujące": "Pending",
        "Oczekujący na publikację": "Awaiting publication",
        "Oczekuje na płatność": "Awaiting payment",
        "Oczekuje na wysłanie": "Pending to send",
        "Odbiór osobisty": "In-store pickup",
        "Odbiorca": "Recipient",
        "Odbiorca (firma)": "Recipient (company)",
        "Oddziel kolejne wartości przecinkami.": "Separate values with commas.",
        "Odpiąć cechę od grupy? Cecha pozostanie w katalogu.": "Unlink feature from group? Feature will remain in catalog.",
        "Odrzucone": "Rejected",
        "Odrzucony": "Rejected",
        "Odstęp góra i dół": "Top and bottom spacing",
        "Odstęp lewa i prawa": "Left and right spacing",
        "Odstępy i obramowanie": "Spacing and border",
        "Ogólne": "General",
        "Okres działania i powtarzające się przedziały godzinowe.": "Operating period and recurring time slots.",
        "Okres przechowywania historii przeglądanych produktów.": "Retention period for viewed product history.",
        "Określ czas przechowywania nieaktywnych koszyków.": "Set how long inactive carts are retained.",
        "Określ ilość produktu pozostawianą w magazynie.": "Set quantity of product to keep in stock.",
        "Określ miejsce kategorii w katalogu.": "Set category position in catalog.",
        "Określ terminy dostępności formularzy zgłoszeń po zrealizowaniu zamówienia.": "Set when ticket forms are available after an order is completed.",
        "Określ zasady zamawiania dla niezalogowanych klientów i produktów bez dostępnego zapasu.": "Set ordering rules for logged-out customers and products with no available stock.",
        "Określa, czy klient może zamówić produkt mimo braku dostępnego zapasu.": "Specifies whether a customer can order a product when no stock is available.",
        "Opcja przeliczenia": "Conversion option",
        "Opcje dokumentu": "Document options",
        "Opcje elementu": "Item options",
        "Opcjonalna grafika reprezentująca wartość tekstową cechy. Wybierz jeden plik.": "Optional graphic representing a feature's text value. Select one file.",
        "Operacja spowoduje trwałe usunięcie wszystkich kategorii należących do tego katalogu! Czy na pewno chcesz wykonać akcję?": "This operation will permanently delete all categories belonging to this catalog! Are you sure you want to perform this action?",
        "Operator": "Operator",
        "Operator lub moduł obsługujący tę metodę dostawy.": "Operator or module handling this delivery method.",
        "Opinia": "Review",
        "Opinia została usunięta.": "Review has been deleted.",
        "Opinia została zaktualizowana.": "Review has been updated.",
        "Opinie": "Reviews",
        "Opinie produktowe": "Product reviews",
        "Opinie zostały zaktualizowane": "Reviews have been updated",
        "Ogranicz produkty uwzględnione w feedzie.": "Limit the products included in the feed.",
        "Opinii na stronie": "Reviews on page",
        "Opis": "Description",
        "Opis grupy": "Group description",
        "Opis produktu": "Product description",
        "Opis wady": "Defect description",
        "Opis wartości": "Value description",
        "Opis został wygenerowany": "Description has been generated",
        "Opisy": "Descriptions",
        "Opisy prezentowane w sklepie w poszczególnych językach.": "Descriptions displayed in store in different languages.",
        "Opisz, jakich klientów obejmuje grupa i do czego służy.": "Describe which customers the group covers and what it is used for.",
        "Opłacona": "Paid",
        "Opłacone": "Paid",
        "Opłacono": "Paid",
        "Opublikowany": "Published",
        "Oraz (and)": "And (and)",
        "Osoba fizyczna": "Individual",
        "Ostatni miesiąc": "Last month",
        "Ostatni rok": "Last year",
        "Ostatnia aktualizacja:": "Last update:",
        "Ostatnia modyfikacja": "Last modification",
        "Ostatnie 24h": "Last 24 hours",
        "Ostatnie 7 dni": "Last 7 days",
        "Ostatnie 90 dni": "Last 90 days",
        "Ostrzeżenie": "Warning",
        "Otrzymałem(-am) inny produkt niż zamówiony": "I received a different product than the one I ordered",
        "Otrzymałem(-am) niewłaściwy produkt": "I received the wrong product",
        "Oznaczenie metody dostawy i powiązane formy płatności.": "Delivery method label and associated payment methods.",
        "Oznaczenie wyświetlane przy kwotach, np. zł lub €.": "Label displayed next to amounts, e.g. zł or €.",
        "Parametr UTM": "UTM parameter",
        "Parametr UTM został dodany.": "UTM parameter has been added.",
        "Parametr UTM został zaktualizowany.": "UTM parameter has been updated.",
        "Parametr został usunięty.": "Parameter has been deleted.",
        "Parametry logistyczne": "Logistics parameters",
        "Parametry przesyłki używane podczas realizacji zamówienia.": "Shipment parameters used when processing an order.",
        "Parametry UTM": "UTM parameters",
        "PayPal": "PayPal",
        "PayU": "PayU",
        "Pełna treść strony produktu w poszczególnych językach.": "Full product page content in different languages.",
        "Pierwszy wiersz jest nagłówkiem": "First row is header",
        "PIN": "PIN",
        "Planowana data publikacji": "Scheduled publication date",
        "Płatność": "Payment",
        "Płatność przy odbiorze": "Payment on delivery",
        "płatność wyłączona": "payment disabled",
        "Płatność za pobraniem": "Cash on delivery",
        "Płatności": "Payments",
        "Plik CSV": "CSV file",
        "Plik CSV nie zawiera danych.": "CSV file contains no data.",
        "Plik faktury": "Invoice file",
        "Pliki udostępniane z kolekcją.": "Files shared with collection.",
        "Po tym czasie nieaktywny koszyk zostanie usunięty.": "After this time, inactive cart will be deleted.",
        "Po wyłączeniu każda nowa opinia wymaga ręcznego zatwierdzenia.": "When disabled, each new review must be approved manually.",
        "Po zapisaniu promocji nie można zmienić efektów.": "Promotion effects cannot be changed after saving.",
        "Po zapisaniu promocji nie można zmienić efektu.": "Promotion effect cannot be changed after saving.",
        "Po zapisaniu promocji nie można zmienić sklepu.": "Store cannot be changed after saving promotion.",
        "Po zapisaniu promocji nie można zmienić typu kodu.": "Code type cannot be changed after saving promotion.",
        "Po zmianie stawki podatku możesz przeliczyć ceny produktów, zachowując przy tym cenę netto lub brutto. Zachowanie ceny netto przelicza cenę brutto, a zachowanie ceny brutto przelicza cenę netto zgodnie z nową wartością przypisanego podatku.": "After changing tax rate, you can recalculate product prices while keeping net or gross price. Keeping net price recalculates gross price, while keeping gross price recalculates net price according to new value of assigned tax.",
        "Pobiera koszyki według obecności adresu email i czasu od porzucenia. Możesz wybrać kilka okresów jednocześnie.": "Retrieves carts based on whether an email address is present and time since abandonment. You can select several time periods at once.",
        "Pobierz etykietę": "Download label",
        "Pobierz etykiety": "Download labels",
        "Pobranie": "Download",
        "Pobranie kodu promocyjnego": "Download promotional code",
        "Pobranie koszyków": "Download carts",
        "Pochylenie": "Italic",
        "Podatek": "Tax",
        "Podatki": "Taxes",
        "Podatki zostały zaktualizowane": "Taxes have been updated",
        "Podgląd": "Preview",
        "Podgląd kategorii": "Category preview",
        "Podgląd kodu": "Code preview",
        "Podgląd na jasnym i ciemnym tle sklepu.": "Preview on light and dark store backgrounds.",
        "Podgląd zdjęcia produktu": "Product image preview",
        "Podkreślenie": "Underline",
        "Podstawowe informacje": "Basic information",
        "Podstawowe informacje o złożonym zamówieniu.": "Basic information about placed order.",
        "Podsumowanie": "Summary",
        "Podsumowanie opinii": "Review summary",
        "Podsumowanie opinii klientów (AI)": "Customer review summary (AI)",
        "Pogrubienie": "Bold",
        "Pokaż atrybut": "Show attribute",
        "Pokaż kafelki do ostatniego poziomu": "Show tiles up to last level",
        "Pokaż kafelki do wybranego poziomu": "Show tiles up to selected level",
        "Pola z wybranego formularza pojawią się w zgłoszeniu reklamacyjnym.": "Fields from selected form will appear in claim submission.",
        "Pole \"Liczba wyników\" jest wymagane.": "\"Number of results\" field is required.",
        "Pole \"Promocja\" jest wymagane.": "\"Promotion\" field is required.",
        "Pole \"Sklep\" jest wymagane.": "\"Store\" field is required.",
        "Pole \"Sposób prezentacji wartości\" jest wymagane.": "\"Value display method\" field is required.",
        "Pole \"Tryb wyświetlania\" jest wymagane.": "\"Display mode\" field is required.",
        "Pole \"Typ\" jest wymagane.": "\"Type\" field is required.",
        "Pole \"Witryna\" jest wymagane.": "\"Website\" field is required.",
        "Pole dziedziczone z produktu bazowego.": "Field inherited from base product.",
        "Pole z modelu": "Field from model",
        "Pomyłka przy zakupie": "Mistake during purchase",
        "Poprzedni okres": "Previous period",
        "Porzucone koszyki": "Abandoned carts",
        "Posiada wagę": "Has weight",
        "Posiada zdjęcie": "Has image",
        "Potwierdzenie dezaktywacji": "Deactivation confirmation",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie usunięcia. Wykonanie tej akcji nie usunie cechy przypisanej do produktów.": "Deletion confirmation. Performing this action will not remove attribute assigned to products.",
        "Powiadomienia": "Notifications",
        "Powiadomienie": "Notification",
        "Powiadomienie do zamówienia": "Order notification",
        "Powiadomienie zostało dodane.": "Notification has been added.",
        "Powiadomienie zostało usunięte.": "Notification has been deleted.",
        "Powiadomienie zostało zaktualizowane.": "Notification has been updated.",
        "Powód": "Reason",
        "Powód dezaktywacji": "Deactivation reason",
        "Powód dezaktywacji ceny": "Price deactivation reason",
        "Powód reklamacji": "Complaint reason",
        "Poziom kategorii": "Category level",
        "Pozostałe parametry": "Other parameters",
        "Pozostałe zdjęcia": "Other photos",
        "Pozostało do zapłaty": "Remaining to pay",
        "Pozostało do zapłaty: {amount}": "Remaining to pay: {amount}",
        "Pozwól": "Allow",
        "Pozycje zamówienia i ich wartości.": "Order items and their values.",
        "Pozytywna": "Positive",
        "Prawda": "True",
        "Prawda/Fałsz": "True/False",
        "Priorytet": "Priority",
        "Procentowy": "Percentage",
        "Producenci": "Manufacturers",
        "Producent": "Manufacturer",
        "Producent aktywny": "Manufacturer active",
        "Producent został dodany.": "Manufacturer has been added.",
        "Producent został usunięty.": "Manufacturer has been deleted.",
        "Producent został zaktualizowany.": "Manufacturer has been updated.",
        "Produkt": "Product",
        "Produkt bazowy": "Base product",
        "Produkt dodawany jako gratis po spełnieniu progu.": "Product added as a free gift after reaching threshold.",
        "Produkt dodawany jako gratis.": "Product added as a free gift.",
        "Produkt dotarł uszkodzony": "Product arrived damaged",
        "Produkt dotarł za późno": "Product arrived too late",
        "Produkt jest niezgodny z opisem": "Product does not match description",
        "Produkt ma wadę fabryczną": "Product has a manufacturing defect",
        "Produkt nie działa / działa nieprawidłowo": "Product does not work / does not work properly",
        "Produkt nie spełnia oczekiwań": "Product does not meet expectations",
        "Produkt nosi ślady użytkowania": "Product shows signs of use",
        "Produkt o statusie Oczekujący na publikację zostanie opublikowany po tej dacie.": "Product with Pending publication status will be published after this date.",
        "Produkt posiada warianty": "Product has variants",
        "Produkt rekomendowany": "Recommended product",
        "Produkt uszkodzony po dostawie": "Product damaged after delivery",
        "Produkt wygląda inaczej niż na zdjęciach": "Product looks different from photos",
        "Produkt wymaga transportu na palecie.": "Product requires pallet shipping.",
        "Produkt został dodany.": "Product has been added.",
        "Produkt został skopiowany.": "Product has been copied.",
        "Produkt został usunięty.": "Product has been deleted.",
        "Produkt został zaktualizowany.": "Product has been updated.",
        "Produkty": "Products",
        "Produkty komplementarne": "Complementary products",
        "Produkty objęte indywidualnymi kodami.": "Products covered by individual codes.",
        "Produkty otagowane": "Tagged products",
        "Produkty polecane razem z aktualnym produktem.": "Products recommended alongside current product.",
        "Produkty rekomendowane": "Recommended products",
        "Produkty uwzględnione": "Included products",
        "Produkty uwzględnione w promocji": "Products included in promotion",
        "Produkty uzupełniające ofertę aktualnego produktu.": "Products that complement current product's offer.",
        "Produkty w kolekcji": "Products in collection",
        "Produkty w promocji": "Products on promotion",
        "Produkty wraz z wariantami": "Products with variants",
        "Produkty zostały usunięte z systemu": "Products have been removed from system",
        "Produkty zostały zaktualizowane": "Products have been updated",
        "Próg ilościowy": "Quantity threshold",
        "Promocja": "Promotion",
        "Promocja jest w trakcie działania. Możesz zmienić jej nazwę i aktywność; pozostałe parametry są zablokowane.": "Promotion is currently active. You can change its name and status; other parameters are locked.",
        "Promocja obowiązuje tylko w wybranych godzinach każdego dnia.": "Promotion applies only during selected hours each day.",
        "Promocja wiązana": "Bundle promotion",
        "Promocja wiązana została usunięta.": "Bundle promotion has been deleted.",
        "Promocja włączona": "Promotion enabled",
        "Promocja została dodana.": "Promotion has been added.",
        "Promocja została usunięta.": "Promotion has been deleted.",
        "Promocja została zaktualizowana.": "Promotion has been updated.",
        "Promocje": "Promotions",
        "Promocje wiązana": "Bundle promotion",
        "Promocje wiązane": "Bundle promotions",
        "Protokół OAuth - client_id": "OAuth protocol - client_id",
        "Protokół OAuth - client_secret": "OAuth protocol - client_secret",
        "Przecena produktów": "Product discount",
        "Przecena zamówienia": "Order discount",
        "Przeceny": "Discounts",
        "Przeceny produktów": "Product discounts",
        "Przeciągnij cechy, aby ustalić kolejność ich wyświetlania.": "Drag features to set their display order.",
        "Przeciągnij grupy cech, aby ustalić kolejność ich wyświetlania.": "Drag feature groups to set their display order.",
        "Przeciągnij uchwyt, aby zmienić kolejność. Możesz też użyć klawiatury: Spacja, strzałki i Enter.": "Drag the handle to change order. You can also use your keyboard: Space, arrow keys, and Enter.",
        "Przeciągnij wartości, aby ustalić kolejność ich wyświetlania.": "Drag values to set their display order.",
        "Przedrostek": "Prefix",
        "Przekreślenie": "Strikethrough",
        "Przelew tradycyjny": "Bank transfer",
        "Przelewy24": "Przelewy24",
        "Przelicz": "Recalculate",
        "Przelicz podatek": "Recalculate tax",
        "Przelicz podatki": "Recalculate taxes",
        "Przenieś wartość {name}": "Move value {name}",
        "Przewidywany czas realizacji dostawy.": "Estimated delivery fulfillment time.",
        "Przypisane kategorie": "Assigned categories",
        "Przypisany": "Assigned",
        "Przypisuj użytkowników do grupy i zarządzaj jej członkami.": "Assign users to group and manage its members.",
        "Przypisz cechę do grupy, aby uporządkować parametry produktów.": "Assign a feature to a group to organize product parameters.",
        "Przypisz cechy produktów i sprawdź cechy odziedziczone.": "Assign product features and view inherited features.",
        "Przypisz cechy, które mają należeć do tej grupy.": "Assign features that should belong to this group.",
        "Przypisz sklep do wersji językowych witryn.": "Assign a store to website language versions.",
        "Przyrostek": "Suffix",
        "Publikacja": "Publication",
        "Publikuj do": "Publish to",
        "Publikuj od": "Publish from",
        "Rabat": "Discount",
        "Rabaty": "Discounts",
        "Reguła podatkowa stosowana do kosztu dostawy.": "Tax rule applied to shipping cost.",
        "Reguła podatku": "Tax rule",
        "Reklamacja": "Claim",
        "Reklamacje": "Claims",
        "reklamacje / zamówienia": "claims / orders",
        "Reklamacje i zwroty": "Claims and returns",
        "Rekomendacja": "Recommendation",
        "Rezerwacja stanów magazynowych": "Stock reservation",
        "Rezerwacje magazynowe": "Stock reservations",
        "Rodzaj kodu": "Code type",
        "Rodzaj płatności": "Payment type",
        "Równe": "Equal",
        "Rozliczenie": "Settlement",
        "Rozliczenie faktury": "Invoice settlement",
        "Rozliczenie powiązanego zamówienia.": "Settlement of the related order.",
        "Rozmiar i waga paczki": "Package size and weight",
        "Rozmiar nie pasuje": "Size does not fit",
        "Rozmiar, styl i dekoracje tekstu.": "Text size, style, and decoration.",
        "Różne": "Other",
        "Rozpoczęto checkout": "Checkout started",
        "Ścieżki": "Paths",
        "Secret ID": "Secret ID",
        "Sesje": "Sessions",
        "Siatka": "Grid",
        "Sklep": "Store",
        "Sklep został dodany.": "Store has been added.",
        "Sklep został usunięty.": "Store has been deleted.",
        "Sklep został zaktualizowany.": "Store has been updated.",
        "Sklepy": "Stores",
        "Skonfiguruj zawartość": "Configure content",
        "Skopiowano": "Copied",
        "Skopiowano do schowka.": "Copied to clipboard.",
        "SKU": "SKU",
        "Slider": "Slider",
        "Słowa kluczowe": "Keywords",
        "Słowa opisujące kategorię. Możesz oddzielić je przecinkami.": "Words describing category. You can separate them with commas.",
        "Sortowanie cech": "Feature sorting",
        "Sortowanie grup cech": "Feature group sorting",
        "Sortowanie wartości": "Value sorting",
        "Sortowanie wartości cechy": "Feature value sorting",
        "Sortuj": "Sort",
        "Sortuj cechy": "Sort features",
        "Sortuj grupy cech": "Sort feature groups",
        "Sposób dostawy": "Shipping method",
        "Sposób dostawy włączony": "Shipping method enabled",
        "Sposób dostawy został dodany.": "Shipping method has been added.",
        "Sposób dostawy został usunięty.": "Shipping method has been deleted.",
        "Sposób dostawy został zaktualizowany.": "Shipping method has been updated.",
        "Sposób łączenia warunków": "Condition combination method",
        "Sposób płatności": "Payment method",
        "Sposób płatności włączony": "Payment method enabled",
        "Sposób płatności został dodany.": "Payment method has been added.",
        "Sposób płatności został usunięty.": "Payment method has been deleted.",
        "Sposób płatności został zaktualizowany.": "Payment method has been updated.",
        "Sposób prezentacji cen": "Price display method",
        "Sposób prezentacji wartości": "Value display method",
        "Sposób przekazania przesyłki klientowi.": "Method of delivering shipment to customer.",
        "Sposób wyświetlania": "Display method",
        "Sposób wyświetlania kafelków kategorii": "Category tile display method",
        "Spróbuj ponownie": "Try again",
        "Sprzedaż": "Sales",
        "Sprzedaż brutto": "Gross sales",
        "Sprzedaż całkowita": "Total sales",
        "Sprzedaż netto": "Net sales",
        "Średnia": "Average",
        "Środowisko": "Environment",
        "Środowisko testowe lub produkcyjne integracji.": "Test or production environment for integration.",
        "Stały": "Fixed",
        "Stan magazynowy": "Stock level",
        "Stan magazynu": "Inventory",
        "Standalone": "Standalone",
        "Standardowy": "Standard",
        "Status": "Status",
        "Status (Draft, WaitingForPublication, Published)": "Status (Draft, WaitingForPublication, Published)",
        "Status dostawy": "Shipping status",
        "Status faktury": "Invoice status",
        "Status i wartość zamówienia.": "Order status and value.",
        "Status koszyka": "Cart status",
        "Status kupującego": "Buyer status",
        "Status opinii": "Review status",
        "Status płatności": "Payment status",
        "Status reklamacji został zmieniony.": "Claim status has been changed.",
        "Status zamówienia": "Order status",
        "Status zwrotu został zmieniony.": "Return status has been changed.",
        "Stawka domyślna": "Default rate",
        "Stawka podatku": "Tax rate",
        "Stawka została dodana.": "Rate has been added.",
        "Stawka została usunięta.": "Rate has been deleted.",
        "Stawka została zaktualizowana.": "Rate has been updated.",
        "Stawki podatkowe obowiązujące w wybranym kraju.": "Tax rates applicable in selected country.",
        "Stawki podatku w poszczególnych państwach": "Tax rates in individual countries",
        "Stosowana dla produktów bez własnej reguły podatku.": "Applied to products without their own tax rule.",
        "Strefa czasowa": "Time zone",
        "Strefa czasowa używana przez sklep przy obsłudze dat i godzin.": "Time zone used by store to handle dates and times.",
        "Strona producenta": "Manufacturer's website",
        "Struktura dokumentu": "Document structure",
        "Styl dekoracji tekstu": "Text decoration style",
        "Styl obramowania": "Border style",
        "Sugerowane ceny": "Suggested prices",
        "Suma cen produktów od której naliczany jest rabat (brutto)": "Total product price at which discount is applied (gross)",
        "Symbol": "Symbol",
        "Symbol identyfikujący ten zakres cen dostawy.": "Symbol identifying this delivery price range.",
        "Symbol kategorii": "Category symbol",
        "Symbol kolekcji": "Collection symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -.": "Symbol can contain only lowercase letters, digits, and the - character.",
        "Symbol może składać się z małych liter, cyfr oraz znaku -.": "Symbol can contain lowercase letters, digits, and the - character.",
        "Symbol może zawierać małe litery, cyfry i znak -.": "Symbol can contain lowercase letters, digits, and the - character.",
        "Symbol produktu": "Product symbol",
        "Synchronizuj": "Synchronize",
        "System opinii": "Review system",
        "System opinii włączony": "Review system enabled",
        "Szablon": "Template",
        "Szczegółowe informacje o producencie w poszczególnych językach.": "Detailed manufacturer information in each language.",
        "Szczegóły faktury": "Invoice details",
        "Szczegóły klienta": "Customer details",
        "Szczegóły kolekcji": "Collection details",
        "Szczegóły opinii": "Review details",
        "Szczegóły reklamacji": "Complaint details",
        "Szczegóły zamówienia": "Order details",
        "Szczegóły zgłoszenia": "Ticket details",
        "Szczegóły zwrotu": "Return details",
        "Szerokość": "Width",
        "Szerokość paczki": "Package width",
        "Szkic": "Draft",
        "szt": "pcs",
        "szt.": "pcs.",
        "Szukaj kategorii": "Search categories",
        "Szukaj kategorii…": "Search categories…",
        "Ta forma dostawy jest wyłączona": "This delivery method is disabled",
        "Tabela": "Table",
        "Tak": "Yes",
        "Tekst": "Text",
        "Tekst wyświetlany podczas ustawienia blokady": "Text displayed when the lock is enabled",
        "Telefon": "Phone",
        "Temat": "Subject",
        "Ten moduł nie wymaga dodatkowej konfiguracji webservice.": "This module does not require additional web service configuration.",
        "Token API ShipX": "ShipX API token",
        "Token dostępu do API obsługującego przesyłki InPost.": "API access token for handling InPost shipments.",
        "Token Geowidget": "Geowidget token",
        "Token mapy punktów odbioru InPost.": "InPost pickup point map token.",
        "tPay": "tPay",
        "Treść": "Content",
        "Treść notatki": "Note content",
        "Treść opinii": "Review content",
        "Treść prezentowana klientom sklepu.": "Content displayed to store customers.",
        "Trwa generowanie opisu": "Description is being generated",
        "Tryb wyświetlania": "Display mode",
        "Trzyliterowy kod waluty, np. PLN lub EUR.": "Three-letter currency code, e.g. PLN or EUR.",
        "Tworzenie cennika": "Creating a price list",
        "Tworzenie faktury": "Creating an invoice",
        "Tworzenie wariantów": "Creating variants",
        "Typ": "Type",
        "Typ (Standard, Pack)": "Type (Standard, Pack)",
        "Typ danych": "Data type",
        "Typ danych listy": "List data type",
        "Typ dostawy": "Delivery type",
        "Typ elementu": "Item type",
        "Typ kodu i ograniczenia jego wykorzystania.": "Code type and usage restrictions.",
        "Typ notatki": "Note type",
        "Typ parametru UTM": "UTM parameter type",
        "Typ produktu i jego dostępność na stronie.": "Product type and its availability on the website.",
        "Typ rabatu": "Discount type",
        "Typ widgetu": "Widget type",
        "Typografia": "Typography",
        "Typu nie można zmienić po utworzeniu.": "Type cannot be changed after creation.",
        "Udział procentowy": "Percentage share",
        "Ukryj atrybut": "Hide attribute",
        "Ukryj kafelki": "Hide tiles",
        "Ukryj kafelki lub pokaż je do ostatniego albo wskazanego poziomu kategorii.": "Hide tiles or display them up to the last or specified category level.",
        "Ulica": "Street",
        "URL płatności": "Payment URL",
        "Ustal, jak długo i ile ostatnio oglądanych produktów ma pozostać w historii klienta.": "Set how long and how many recently viewed products remain in customer history.",
        "Ustaw czas rezerwacji produktów oraz minimalny i maksymalny poziom logistyczny.": "Set product reservation time and minimum and maximum logistics levels.",
        "Ustaw priorytet względem innych grup klientów.": "Set priority relative to other customer groups.",
        "Ustaw procentową stawkę dla każdego kraju.": "Set the percentage rate for each country.",
        "Ustaw sposób wyświetlania i akceptowania opinii produktów.": "Set how product reviews are displayed and approved.",
        "Ustaw status": "Set status",
        "Ustawienia cechy": "Feature settings",
        "Ustawienia darmowego produktu": "Free product settings",
        "Ustawienia darmowej dostawy": "Free shipping settings",
        "Ustawienia domyślne": "Default settings",
        "Ustawienia eksportu": "Export settings",
        "Ustawienia kategorii": "Category settings",
        "Ustawienia kodu pocztowego": "Postal code settings",
        "Ustawienia kodu rabatowego": "Discount code settings",
        "Ustawienia listy": "List settings",
        "Ustawienia podatku": "Tax settings",
        "Ustawienia podstawowe": "Basic settings",
        "Ustawienia produktu": "Product settings",
        "Ustawienia rabatu": "Discount settings",
        "Ustawienia sklepu": "Store settings",
        "Ustawienia sposobu dostawy": "Delivery method settings",
        "Ustawienia sposobu płatności": "Payment method settings",
        "Ustawienia webservice": "Web service settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "Delete",
        "Usuń atrybut": "Delete attribute",
        "Usuń cechę": "Delete feature",
        "Usuń element": "Delete item",
        "Usuń etykietę": "Delete label",
        "Usuń katalog": "Delete catalog",
        "Usuń kategorię": "Delete category",
        "Usuń notatkę": "Delete note",
        "Usuń powiązanie": "Delete association",
        "Usuń producenta": "Delete manufacturer",
        "Usuń produkt z kolekcji": "Remove product from collection",
        "Usuń produkt z promocji": "Remove product from promotion",
        "Usuń wartość": "Delete value",
        "Usuń warunek": "Delete condition",
        "Usun właściwość": "Delete property",
        "Usuń z grupy": "Remove from group",
        "Usuń z zestawu": "Remove from set",
        "Usuń zakres": "Delete range",
        "Usunąć ten zakres cen dostawy?": "Delete this delivery price range?",
        "Utwórz": "Create",
        "Utworzona": "Created",
        "Utworzono": "Created",
        "Uzupełnij wymagane mapowanie pliku CSV.": "Complete the required CSV file mapping.",
        "Uzupełniono": "Completed",
        "Użycia": "Usage",
        "Użytkownik": "User",
        "Użytkownik został odpięty od grupy klientów.": "User has been removed from customer group.",
        "Użytkownik został przypisany do grupy klientów.": "User has been assigned to customer group.",
        "Użyty": "Used",
        "vs poprzedni okres": "vs previous period",
        "W magazynie": "In stock",
        "W temacie i treści wiadomości można korzystać z systemu szablonów języka Liquid do parsowania danych pochodzących z zamówienia.": "You can use Liquid templating language in the subject and message body to parse data from an order.",
        "W trakcie realizacji": "In progress",
        "W trakcie rozpatrywania": "Under review",
        "Waga": "Weight",
        "Waga paczki": "Package weight",
        "Waga produktu": "Product weight",
        "Waga produktu w kilogramach.": "Product weight in kilograms.",
        "Waga przygotowanej paczki w kilogramach.": "Weight of prepared package in kilograms.",
        "Waluta": "Currency",
        "Waluta rozliczeń sklepu. Jej zmiana wymaga ponownego wyboru kraju.": "Store billing currency. Changing it requires selecting a country again.",
        "Waluta została dodana.": "Currency has been added.",
        "Waluta została usunięta.": "Currency has been deleted.",
        "Waluta została zaktualizowana.": "Currency has been updated.",
        "Waluty": "Currencies",
        "Wariant produktu": "Product variant",
        "Wariant został usunięty.": "Variant has been deleted.",
        "Warianty": "Variants",
        "Warianty dodane: {count}": "Variants added: {count}",
        "Warianty produktu zostały utworzone.": "Product variants have been created.",
        "Warianty usunięte: {count}": "Variants deleted: {count}",
        "Wartość": "Value",
        "Wartość numeryczna": "Numeric value",
        "Wartość przed doliczeniem kosztów dostawy (brutto).": "Value before adding delivery costs (gross).",
        "Wartość rabatu": "Discount value",
        "Wartość rabatu (brutto)": "Discount value (gross)",
        "Wartość tekstowa": "Text value",
        "Wartość wybierana przy uzupełnianiu cechy produktu. Przygotuj jej wersje językowe.": "Value selected when completing a product attribute. Prepare translations for it.",
        "Wartość wymagana": "Required value",
        "Wartość z modelu": "Value from model",
        "Wartość zamówień": "Order value",
        "Wartość została dodana.": "Value has been added.",
        "Wartość została usunięta.": "Value has been deleted.",
        "Wartość została zaktualizowana.": "Value has been updated.",
        "Wartości": "Values",
        "Wartości cechy": "Attribute values",
        "Wartości numeryczne": "Numeric values",
        "Wartości procentowe lub kwoty brutto w walucie sklepu.": "Percentage values or gross amounts in store currency.",
        "Wartości są liczbami całkowitymi. Typ można wybrać tylko podczas tworzenia cechy.": "Values are integers. Type can only be selected when creating an attribute.",
        "Warunki": "Conditions",
        "Warunki wyświetlania atrybutu": "Attribute display conditions",
        "Ważna": "Valid",
        "Wczytaj": "Load",
        "Wczytaj cechy ponownie": "Reload attributes",
        "Wczytanie kategorii zastąpi bieżącą listę produktów.": "Loading a category will replace current product list.",
        "Wczytano dane z pliku CSV.": "Data loaded from CSV file.",
        "Wczytywanie kategorii": "Loading categories",
        "Wersja (version)": "Version (version)",
        "Wersja API": "API version",
        "Wewnętrzne informacje dotyczące obsługi zamówienia.": "Internal information about order processing.",
        "Wiadomość": "Message",
        "Widget służy do pobierania kodów promocyjnych z wybranej promocji.": "Widget is used to retrieve promotional codes from selected promotion.",
        "Widget służy do wczytania treści powiadomienia według wybranej statusu i wersji językowej.": "Widget is used to load notification content based on selected status and language.",
        "Widoczność i położenie": "Visibility and position",
        "Widoczność produktu w modułach z rekomendacjami.": "Product visibility in recommendation modules.",
        "Większe lub równe": "Greater than or equal to",
        "Większe niż": "Greater than",
        "Wielkość obramowania": "Border size",
        "Wielkość tekstu": "Text size",
        "Wiersze do importu:": "Rows to import:",
        "Witryna": "Website",
        "Witryna i język": "Website and language",
        "Witryny": "Websites",
        "Wklej pełną konfigurację eksportu (name, locale, websiteId, source, format, schema).": "Paste full export configuration (name, locale, websiteId, source, format, schema).",
        "Wklejony tekst nie jest poprawnym JSON.": "Pasted text is not valid JSON.",
        "Włącz dni wysyłki i wskaż godzinę dla każdego z nich.": "Enable shipping days and specify a time for each one.",
        "Włącz dodatkowe pola dla reklamacji": "Enable additional fields for complaints",
        "Włącz dostępność metody płatności w krajach i określ jej koszt.": "Enable payment method availability in countries and set its cost.",
        "Włącz, aby w polu daty określić także godzinę rozpoczęcia i zakończenia.": "Enable setting a start and end time in the date field.",
        "Właściwości": "Properties",
        "Własna wartość": "Custom value",
        "Własny przedział": "Custom range",
        "Wpis aktywny": "Active entry",
        "Wpis aktywny: {name}": "Active entry: {name}",
        "Wpis do kalendarza": "Calendar entry",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wpis do kalendarza został zaktualizowany.": "Calendar entry has been updated.",
        "Wpis w kalendarzu został dodany.": "Calendar entry has been added.",
        "Wpis w kalendarzu został zaktualizowany.": "Calendar entry has been updated.",
        "Wpisz liczbę całkowitą. Wartość może być również zerowa lub ujemna.": "Enter an integer. Value can also be zero or negative.",
        "Wpisz treść notatki, maksymalnie 255 znaków.": "Enter note text, up to 255 characters.",
        "Wpisz wartości po przecinku.": "Enter values separated by commas.",
        "Wpływ na wariantowość produktu": "Impact on product variants",
        "Wprowadź treść notatki widocznej tylko dla obsługi": "Enter note text visible only to support staff",
        "Wszystkie": "All",
        "Wszystkie kategorie": "All categories",
        "Wszystkie statusy": "All statuses",
        "Wszystkie wersje językowe zostały już przypisane do innych sklepów.": "All language versions have already been assigned to other stores.",
        "Wszystko": "Everything",
        "Wybierz": "Select",
        "Wybierz cechę": "Select feature",
        "Wybierz cechę i kliknij plus, aby dodać ją do listy. Zmiany przypisań zostaną utrwalone po zapisaniu grupy.": "Select a feature and click the plus sign to add it to the list. Assignment changes will be saved when you save the group.",
        "Wybierz ceny brutto z podatkiem lub ceny netto bez podatku.": "Select gross prices including tax or net prices excluding tax.",
        "Wybierz darmowy produkt": "Select free product",
        "Wybierz element": "Select item",
        "Wybierz element do edycji klikając na niego w strukturze.": "Select an item to edit by clicking it in the structure.",
        "Wybierz element, aby skonfigurować jego nazwę, wartość i warunki.": "Select an item to configure its name, value, and conditions.",
        "Wybierz etykietę": "Select label",
        "Wybierz etykietę produktu": "Select product label",
        "Wybierz etykietę, którą chcesz przypisać do produktów": "Select the label you want to assign to products",
        "Wybierz etykiety dostępne w tym sklepie.": "Select labels available in this store.",
        "Wybierz formularz uzupełniający zgłoszenie reklamacyjne.": "Select the form for submitting a complaint.",
        "Wybierz katalog z systemu": "Select catalog from system",
        "Wybierz katalogi używane w sklepie.": "Select catalogs used in the store.",
        "Wybierz katalogi, z których sklep ma korzystać przy prezentacji kategorii.": "Select catalogs the store should use to display categories.",
        "Wybierz kategorię": "Select category",
        "Wybierz kategorię z przypisanymi cechami, aby uzupełnić ich wartości.": "Select a category with assigned features to fill in their values.",
        "Wybierz kategorię z systemu": "Select category from system",
        "Wybierz kategorię, którą chcesz przypisać do produktów": "Select the category you want to assign to products",
        "Wybierz kolekcję, którą chcesz przypisać do produktów": "Select the collection you want to assign to products",
        "Wybierz kolumnę.": "Select column.",
        "Wybierz kraj, aby zobaczyć dostępne dostawy.": "Select a country to view available shipping methods.",
        "Wybierz opcję": "Select option",
        "Wybierz opinie dla których chcesz wykonać akcje": "Select reviews for which you want to perform actions",
        "Wybierz plik CSV": "Select CSV file",
        "Wybierz początek i koniec okresu obowiązywania wpisu.": "Select the start and end date of the entry's validity period.",
        "Wybierz podatek z systemu": "Select tax from system",
        "Wybierz pozycję i kliknij plus, aby dodać ją do listy.": "Select an item and click the plus sign to add it to the list.",
        "Wybierz producenta": "Select manufacturer",
        "Wybierz producenta i kliknij plus. Dodane pozycje są pomijane.": "Select a manufacturer and click the plus sign. Added items are skipped.",
        "Wybierz producenta, którego chcesz przypisać do produktów": "Select the manufacturer you want to assign to products",
        "Wybierz produkt": "Select product",
        "Wybierz produkty dla których chcesz wykonać akcje": "Select products for which you want to perform actions",
        "Wybierz produkty powiązane z tą kolekcją.": "Select products associated with this collection.",
        "Wybierz produkty wchodzące w skład zestawu i określ ich ilość.": "Select products included in the set and specify their quantity.",
        "Wybierz sklep": "Select store",
        "Wybierz status": "Select status",
        "Wybierz status który chcesz przypisać do opinii": "Select the status you want to assign to reviews",
        "Wybierz status, który chcesz ustawić w produktach": "Select the status you want to set for products",
        "Wybierz status...": "Select status...",
        "Wybierz wartość z listy lub podaj własną.": "Select a value from the list or enter your own.",
        "Wybierz witrynę": "Select website",
        "Wybierz zakres dat": "Select date range",
        "Wybierz zakres godzinowy": "Select time range",
        "Wybierz zamówienie z listy.": "Select an order from the list.",
        "Wybierz źródło": "Select source",
        "Wybór strony do przekierowania": "Select page to redirect to",
        "Wybrana dostawa i stan przesyłki.": "Selected shipping method and shipment status.",
        "Wybrana kolumna nie zawiera danych.": "Selected column contains no data.",
        "Wybrana kolumna zawiera wartości inne niż liczby.": "Selected column contains non-numeric values.",
        "Wybrana kolumna zawiera wartości z nieprawidłowym formatem daty.": "Selected column contains values with an invalid date format.",
        "Wybrana metoda i rozliczenie płatności.": "Selected payment method and settlement.",
        "Wybrane etykiety": "Selected labels",
        "Wybrane pole jest tablicą wartości. W wygenerowanym pliku elementy zostaną połączone przecinkami.": "Selected field is an array of values. Items will be separated by commas in the generated file.",
        "Wybrane produkty": "Selected products",
        "Wybrani producenci": "Selected manufacturers",
        "Wybranie etykiety produktu jest wymagane": "Selecting a product label is required",
        "Wybranie formatu jest wymagane": "Selecting a format is required",
        "Wybranie kategorii jest wymagane": "Selecting a category is required",
        "Wybranie limitu jest wymagane": "Selecting a limit is required",
        "Wybranie producenta jest wymagane": "Selecting a manufacturer is required",
        "Wybranie produktu jest wymagane": "Selecting a product is required",
        "Wybrano jedną opinię.": "One review selected.",
        "Wybranych opinii: %0": "Reviews selected: %0",
        "Wybranych produktów:": "Products selected:",
        "Wyczyść cechę we wszystkich językach: {name}": "Clear feature in all languages: {name}",
        "Wyczyść maksymalną wartość rabatu": "Clear maximum discount value",
        "Wyczyść wartość cechy: {name}": "Clear feature value: {name}",
        "Wygenerowanie nowych kodów spowoduje usunięcie wszystkich istniejących kodów dla tej promocji. Usunięte kody są nieważne i nie można ich już użyć.": "Generating new codes will delete all existing codes for this promotion. Deleted codes are invalid and can no longer be used.",
        "Wygeneruj feed": "Generate feed",
        "Wygeneruj z nazwy": "Generate from name",
        "Wygląd etykiety dla wybranej wersji językowej.": "Label appearance for selected language version.",
        "Wykres kołowy": "Pie chart",
        "Wykres słupkowy poziomy": "Horizontal bar chart",
        "Wyłącz wpis, aby nie był aktywny w wybranym okresie.": "Disable entry so it is inactive during the selected period.",
        "Wyłącz, aby dezaktywować grupę bez jej usuwania.": "Disable to deactivate the group without deleting it.",
        "Wyłączenie ukrywa opinie w sklepie i blokuje dodawanie nowych.": "Disabling hides reviews in the store and prevents new ones from being added.",
        "Wyłączona promocja nie działa niezależnie od daty.": "Disabled promotion does not work, regardless of date.",
        "Wymaga uzupełnienia tej cechy w produktach, do których jest przypisana.": "Requires this feature to be completed for products it is assigned to.",
        "Wymagalność i format adresu pocztowego.": "Postal address requirement and format.",
        "Wymagany kod pocztowy": "Postal code required",
        "Wymiary etykiety oraz wygląd jej krawędzi.": "Label dimensions and edge appearance.",
        "Wysłane": "Sent",
        "Wysokość": "Height",
        "Wysokość paczki": "Package height",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Server error occurred during selected operation. Try again.",
        "Wystąpił problem podczas generowania opisu.": "A problem occurred while generating the description.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Errors in form. Check all form fields.",
        "Wystawiona ocena": "Rating given",
        "Wyświetlaj zawartość jako CDATA": "Display content as CDATA",
        "Wyświetlanie pól": "Field display",
        "Wyświetlenia produktu": "Product views",
        "Wysyłka na palecie": "Pallet shipping",
        "Wysyłka: {day}": "Shipping: {day}",
        "Wyszukaj cechę...": "Search feature...",
        "Wyszukaj etykietę...": "Search label...",
        "Wyszukaj etykietę…": "Search label…",
        "Wyszukaj grupę cech…": "Search feature group…",
        "Wyszukaj i dodaj etykiety, które mają być dostępne w tym sklepie.": "Search for and add labels to make available in this store.",
        "Wyszukaj kategorię...": "Search category...",
        "Wyszukaj kolekcję...": "Search collection...",
        "Wyszukaj kraj...": "Search country...",
        "Wyszukaj kraj…": "Search country…",
        "Wyszukaj podatek…": "Search tax…",
        "Wyszukaj producenta...": "Search manufacturer...",
        "Wyszukaj producenta…": "Search manufacturer…",
        "Wyszukaj produkt...": "Search product...",
        "Wyszukaj produkt…": "Search product…",
        "Wyszukaj rodzaj płatności...": "Search payment method...",
        "Wyszukaj sklep...": "Search store...",
        "Wyszukaj sposób dostawy...": "Search shipping method...",
        "Wyszukaj użytkownika...": "Search user...",
        "Wyszukaj walutę...": "Search currency...",
        "Wzór kodu pocztowego": "Postal code pattern",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji.": "Postal code pattern displayed in validation error message.",
        "z {amount}": "from {amount}",
        "Z adresem email": "With email address",
        "Zaakceptowane": "Accepted",
        "Zaakceptowany": "Accepted",
        "Zachowaj cenę brutto": "Keep gross price",
        "Zachowaj cenę netto": "Keep net price",
        "Zachowanie przy braku towaru na stanie": "Behavior when item is out of stock",
        "zacznij pisac aby wyszukac etykiete...": "start typing to search for a label...",
        "zacznij pisać aby wyszukać kraj...": "start typing to search for a country...",
        "zacznij pisac aby wyszukac producenta...": "start typing to search for a manufacturer...",
        "zacznij pisać aby wyszukać promocję...": "start typing to search for a promotion...",
        "zacznij pisać aby wyszukać sklep...": "start typing to search for a store...",
        "zacznij pisać aby wyszukać walutę...": "start typing to search for a currency...",
        "zacznij pisac aby wyszukac wartość...": "start typing to search for a value...",
        "zacznij pisac aby wyszukac właściwość...": "start typing to search for a property...",
        "Zacznij pisać, aby wyszukać cechę…": "Start typing to search for a feature…",
        "Zaczyna się od": "Starts with",
        "Zakończ edycję adresu": "Finish editing address",
        "Zakres": "Range",
        "Zakres dat wpisu": "Entry date range",
        "Zakup": "Purchase",
        "Załączniki": "Attachments",
        "Załaduj": "Load",
        "Zamawianie bez rejestracji": "Guest checkout",
        "Zamówienia": "Orders",
        "Zamówienia klienta": "Customer orders",
        "Zamówienia: {count}": "Orders: {count}",
        "Zamówienie": "Order",
        "Zamówienie firmowe": "Company order",
        "Zamówienie wymaga uwagi": "Order requires attention",
        "Zamówienie wymaga uwagi. Otwórz je, aby sprawdzić szczegóły.": "Order requires attention. Open it to check the details.",
        "Zamówienie złożone": "Order placed",
        "Zamówienie zostało zaktualizowane.": "Order has been updated.",
        "Zamówiłem(-am) kilka wariantów i zostawiam tylko jeden": "I ordered several variants and am keeping only one",
        "Zapisane wersje dokumentu.": "Saved document versions.",
        "Zapisuj logi": "Save logs",
        "Zapisz": "Save",
        "Zapisz cechę, aby dodać jej wartości.": "Save feature to add its values.",
        "Zapisz grupę, aby dodać do niej klientów.": "Save group to add customers to it.",
        "Zapisz i wróć": "Save and back",
        "Zapisz kolejność": "Save order",
        "Zapisz notatkę": "Save note",
        "Zapisz promocję, aby zarządzać indywidualnymi kodami.": "Save promotion to manage individual codes.",
        "Zapisz zmiany": "Save changes",
        "Zapłacono": "Paid",
        "Zapłacono brutto": "Paid gross",
        "Zarezerwowana ilość": "Reserved quantity",
        "Zastąp produktami kategorii": "Replace with products from category",
        "Zastosowanie konfiguracji usunie warianty niepasujące do wybranych wartości.": "Applying configuration will remove variants that don't match selected values.",
        "Zastosuj": "Apply",
        "Zawartość elementu": "Item content",
        "Zawiera": "Contains",
        "Zawiera produkt": "Contains product",
        "Zaznacz dostępne sposoby dostawy. Pod każdym widać przypisane formy płatności; nieaktywne dostawy pozostają zablokowane.": "Select available shipping methods. Assigned payment methods are shown below each one; inactive shipping methods remain unavailable.",
        "Zaznacz wersje językowe witryn obsługiwane przez sklep. Wersje przypisane do innych sklepów są zablokowane.": "Select website language versions supported by the store. Versions assigned to other stores are unavailable.",
        "Zaznaczona kategoria jest kategorią główną produktu.": "Selected category is the product's main category.",
        "Zdecyduj, na jakich poziomach katalogu klient zobaczy kafelki kategorii.": "Choose catalog levels where customers will see category tiles.",
        "Zdezaktywowany": "Deactivated",
        "Zdjęcia": "Photos",
        "Zdjęcie": "Photo",
        "Zdjęcie główne": "Main photo",
        "Ze statusu": "From status",
        "Zestaw": "Set",
        "Zewnętrzna głębokość przygotowanej paczki w centymetrach.": "External depth of prepared package in centimeters.",
        "Zewnętrzna szerokość przygotowanej paczki w centymetrach.": "External width of prepared package in centimeters.",
        "Zewnętrzna wysokość przygotowanej paczki w centymetrach.": "External height of prepared package in centimeters.",
        "Zmiana statusu": "Status change",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmień kolejność wartości cechy": "Change feature value order",
        "Zmień nazwę katalogu": "Rename directory",
        "Zmień status": "Change status",
        "Zmodyfikowane przez": "Modified by",
        "Zniżka została usunięta.": "Discount has been deleted.",
        "Zrealizowane": "Completed",
        "Żródła": "Sources",
        "Źródło": "Source",
        "Źródło (utm_source)": "Source (utm_source)",
        "Źródło danych": "Data source",
        "Źródło pochodzenia statusu": "Status origin",
        "Źródło zdarzenia, temat i treść wiadomości.": "Event source, subject, and message content.",
        "Zwolniono": "Released",
        "Zwrot": "Return",
        "Zwroty": "Returns",
        "zwroty / zamówienia": "returns / orders",
        "Zwykły tekst": "Plain text"
    }
};
